import { LanguageCodes } from '../SettingsService';
import { NeuroTranslationStates } from './neuro-translation.model';
export const isNeuroTranslated = (input: string, currentLang: LanguageCodes): boolean => {
	return input === NeuroTranslationStates.TRANSLATED && currentLang !== LanguageCodes.ESTONIAN;
};
